import $ from 'jquery';
import datepickerFactory from 'jquery-datepicker';
import fitVids from './jquery.fitvids.js';
import Vimeo from '@vimeo/player';
import slick from 'slick-carousel';
import 'jquery.cookie';
import jQueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';
import 'isotope-packery';
import select2 from 'select2';
jQueryBridget( 'isotope', Isotope, $ );    
datepickerFactory($); 
 

/**
 * Variables
 */
  
 const windowWidth = $(window).width();
 const isDesktop = windowWidth <= 1200;
 const isMd = windowWidth <= 1025;
 const isTablet = windowWidth <= 768;
 const isMobile = windowWidth <= 480;


/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

 const toggleMenu = (event) => {
  event.preventDefault();
  $('.js-menu-toggle, .header__navigation').toggleClass('open');
  $('.header').toggleClass('menu-open');
};

$('.js-menu-toggle').on('click', toggleMenu);


/**
 * Accordion
 */

 $(window).on('load', function() {

  var first = $('.module-navigation__single').first().addClass('open');
  $(first).next('dd').addClass('open');

  var link = $('.completed');
  var div = $(link).last().parent();
  var dd = $(div).parent();
  var dt = $(dd).prev();
  var target = $(dt).next('dd');


  $(dt).addClass('open');
  $('dd').not(dd).removeClass('open');
  $('dt').not(dt).removeClass('open');
  target.addClass('open');
  target.slideToggle();

  $('.accordion dd').not('.accordion dd.open').hide();

});


 $('.accordion dt').on('click', function(e) {
  $(this).toggleClass('open');
  e.preventDefault();
  var target = $(this).next('dd');
  var parent = $(this).parent('dl');
  target.toggleClass('open');
  target.slideToggle();
  parent.toggleClass('active');
});

/* *
 * Fit Vids
 * */


 $('.video').fitVids();


/* *
 * Course Navigation
 * */

 $('.course__navigation__tab').on('click', function(e) {
  $('.course__navigation__tab').not($(this)).removeClass('selected');
  $(this).addClass('selected');

  var tab = $(this).data('tab');
  var target = $('.course__module--purchased[data-tab="' + tab + '"]')

  $('.course__module--purchased').removeClass('active');
  target.addClass('active');

});


/* *
 * Share Modal
 * */

 $('.btn--share').on('click', function(e) { 
  $('.share-modal').fadeIn().addClass('visible');
  $('.share-modal__close').on('click', function(e) { 
    $('.share-modal').fadeOut().removeClass('visible');
  });
});


/* *
 * Video Modal
 * */

 $('.module__child a').on('click', function(e) {
  event.preventDefault();

  var link = (this);
  var target = $(this).next('dd');
  var id = getVimeoId(this.href);
  var iframe = document.querySelector('#video iframe');
  var player = new Vimeo(iframe);
  var counter = $('.completed-counter').text();
  var totalModules = $('.total-module-counter').text();
  var progress_bar = $('[data-attribute="progress"]');
  if (counter < totalModules) {
    var newValue = parseInt(parseFloat(counter)) + 1;
  } 

  player.loadVideo(id).then(function(id) {
        // The new video is loaded
      }).catch(function(error) {
        switch (error.name) {
          case 'TypeError':
                  // The ID isn't a number
                  break;

                  case 'PasswordError':
                  // The video is password-protected
                  break;

                  case 'PrivacyError':
                  // The video is private
                  break;

                  default:
                  // Some other error occurred
                  break;
                }

              });

      player.off('ended');

      player.on('ended', function() {  
        $(link, target).addClass('completed');
        $('.completed-counter').text(newValue);
        var progress_percentage = (newValue / totalModules * 100) + "%";
        $(progress_bar).css({ "width": progress_percentage });
      });

    });

 $(window).ready(function() {
  var link = $('.completed');
  var div = $(link).last().parent();
  var dd = $(div).parent();
  var dt = $(dd).prev();
  var target = $(dt).next('dd');

  $(dt).addClass('open');
  target.toggleClass('open');
  target.slideToggle();

});

 $(document).ready(function() {

  var iframe = document.querySelector('#video iframe');

  if (!iframe) return false;  

  setInterval(function(){
    var player = new Vimeo(iframe);

    player.getVideoId().then(function(video_id) {

      player.getCurrentTime().then(function(progress) {

        $.ajax({
          method: "POST",
          url: bp.ajax_url,
          data: {
            action: 'save_video_progress',
            video_id: video_id,
            progress: progress,
            post_id: bp.post_id,
          }
        })
        .done(function( msg ) {

        });

      });

    });
  }, 5000);

});


 function getVimeoId( url ) {

  // Look for a string with 'vimeo', then whatever, then a
  // forward slash and a group of digits.
  var match = /vimeo.*\/(\d+)/i.exec( url );

  // If the match isn't null (i.e. it matched)
  if ( match ) {
    // The grouped/matched digits from the regex
    return match[1];
  }

}


/* *
 * Video Preview Modal
 * */

 $('.module__preview').on('click', function(e) { 

  var parent = $(this).parent();
  var target = $(this).next('.video--preview-modal').show().fadeIn();
  var iframe = document.querySelector('#video iframe');
  var player = new Vimeo(iframe);

  $('.modal__dismiss').on('click', function(e) {
    player.pause().then(function() {
      $(target).hide().fadeOut();
    })
  })
});

/* *
 * Category Dropdown
 * */

 $('.category-dropdown').on('click', function(e) {
  $('.category-dropdown__div').slideToggle();
});


/* *
 * Slick Slider
 * */


 $('[data-slider="product"]').slick({
  arrows: false,
  slidesToShow: 3,
  autoplay: false,
  centerMode: true,
  focusOnSelect: true
});

 $('[data-slider="banner"]').slick({
  arrows: false,
  slidesToShow: 5,
  autoplay: true,
  focusOnSelect: true,
  speed: 2000,
  responsive: [
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 2,
    }
  }
  ]
});

 $('[data-slider="logos"]').slick({
  arrows: false,
  slidesToShow: 6,
  autoplay: true,
  focusOnSelect: true,
  speed: 2000,
  responsive: [
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 4,
    }
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 3,
    }
  },
  ]
});

 $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true
});

 $('[data-gotoslide]').on('click', function(e) {
  e.preventDefault();
  var slideIndex = $(this).data('gotoslide');
  $('.slider-for').slick('slickGoTo', parseInt(slideIndex) );
  
});


 $('.hf-form').attr('novalidate', 'novalidate');


/* *
 * Review Modal
 * */

 $('.post__reviews__a').on('click', function(e) {
  e.preventDefault();
  $('.video__player__modal').addClass('display');
});


/* *
 * Post Filter
 * */

 $('.post-filter__type').on('click', function(e) {
  $(this).toggleClass('selected').siblings().removeClass('selected');
});


/**
 * Isotope Grid Filter 
 */

$(window).on('load', function() { 
  var $grid = $('[data-grid]').isotope({
      // options
      itemSelector: '.grid-item',
    });

  $grid.addClass('loaded');

  /**
   * Isotope Filter
   */

  //  var filters = [];

  //  $('.filter__option').on( 'click', function() {

  //   var option = $(this).attr('name');

  //   if( $.inArray(option, filters) !== -1 )
  //   {
  //     filters.splice( $.inArray(option, filters), 1 );
  //   }
  //   else
  //   {
  //     filters.push(option);
  //   }

  //   var filterValue = concatValues( filters );
  //   console.log(filterValue);
  //   $grid.isotope({ filter: filterValue });

  // });

  $('.filter__link').on( 'click', function(e) {

    e.preventDefault();
    var tag = $(this).attr('href');
    tag = tag.replace('#', '.');
    $('.filter__link').removeClass('selected');
    $(this).addClass('selected');

    if (tag == '.all') tag = '*';
    $grid.isotope({ filter: tag });
  });

   $('.filters-select--isotope').on( 'change', function(e) {
    e.preventDefault();
    var filterValue = this.value;
    console.log(filterValue);
    if (filterValue == '.all') filterValue = '*';
    $grid.isotope({ filter: filterValue });
  });

 });

 $(window).on('load', function() {  

  if(window.location.hash && $('[data-isotope]').length) {
    $('a[href="' + window.location.hash + '"]').click();
  }

});

/**
 * Concatinate values
 */

 function concatValues( obj ) {
  var value = '';
  for ( var prop in obj ) {
    value += obj[ prop ];
  }
  return value;
}

/**
 * Filter accordion
 */

$('.filter__category h2').on( 'click', function() {
  $(this).next('.filter__options').slideToggle();
  $(this).toggleClass('open');
});


/* *
 * See More dashboard button
 * */

 $('[data-button="show-grid-items"]').on('click', function() {
  var $grid = $('[data-grid]');
  var $items = $('.grid-item:hidden');
  
  $grid.append( $items ).isotope( 'appended', $items );

  $('[data-button="show-grid-items"]').fadeOut();
  // $('.grid-item:hidden', $(this).parents('.projects-grid')).slice(0, 9).show();
});

/**
 * Isotope Grid Filter 
 */

 $(window).on('load', function() { 
  var $grid = $('[data-grid-groups]').isotope({
      // options
      itemSelector: '.row--dashboard--group',
      stamp: '.row--dashboard--header',
      getSortData: {
        admin_id: '.admin_id parseInt',
        group: '.group',
        date_joined: '.date_joined parseInt',
        renewal_date: '.renewal_date parseInt',
        last_activity: '.last_activity parseInt',
        courses_started: '.courses_started parseInt',
        most_recent_engagement: '.most_recent_engagement parseInt',
        courses_complete_percentage: '.courses_complete_percentage parseInt',
        users: '.users parseInt',
        active_users: '.active_users parseInt',
        engagement: '.engagement parseInt'
      }
    });

  $grid.addClass('loaded');

/**
 * Isotope Filter
 */

 $('.subscription-status-select').on( 'change', function(e) {
  e.preventDefault();
  var filterValue = this.value;
  if (filterValue == '.all') filterValue = '*';
  $grid.isotope({ filter: filterValue });
});

/**
 * Sort Group Statistics data
 */

 $('.row--dashboard--header').on( 'click', '.group-statistics__column-header', function() {
  var siblings = $('.group-statistics__column-header');
  $(this).addClass('active');
  siblings.not(this).removeClass('active');
  var sortByValue = $(this).attr('data-sort-by');

  var direction = $(this).attr('data-sort-direction');

  var isAscending = (direction == 'asc');
  var newDirection = (isAscending) ? 'desc' : 'asc';

  $grid.isotope({ sortBy: sortByValue, sortAscending: isAscending });

  $(this).attr('data-sort-direction', newDirection);

});

 $grid.isotope('updateSortData').isotope();

});



 $(window).on('load', function() {  

  if(window.location.hash && $('[data-isotope]').length) {
    $('a[href="' + window.location.hash + '"]').click();
  }

}); 


/* *
 * Infographic modal
 * */

 $('.infographic__image').on( 'click', function(e) {
  $('.infographic__modal').toggleClass('display');

  $('.modal__dismiss').on('click', function(e) {
    $('.infographic__modal').removeClass('display');
  })
});


/* *
 * References box
 * */

 $('.post__show-all').click( function() {
  $('.post__references').toggleClass('open');
  if ($('.post__references').hasClass('open')){
    $('.post__show-all span').text('Hide');
  } else {
    $('.post__show-all span').text('Show all');
  }
});

/* *
 * Filter Select - Archives
 * */


 $('[data-filter-category]').on('change', function() {
  var category = $(this).val();

  if (category == '.all')
  {
    location.href = location.origin + '/type/infographic/';
  }
  else {
    location.href = location.origin + '/type/infographic/?product_cat=' + category;
  }
  
});

/* *
 * Filter Select - Search
 * */


 $('[data-filter-search]').on('change', function() {
  var category = $(this).val();
  var query = location.href.split('?').pop().split('&')[0];
  if (category == '.all')
  {
    var url = location.origin + '/?' + query;
    window.location = url;
  }
  else
  {
    var url = location.origin + '/?' + query + '&post_type=' + category;
    window.location = url;
  }
  
});

/**
 * Load video if visible
 */

 $(window).on('load', function(){
  if( $('.section--hero').css('display') == 'flex')  {
    var video = ( '.hero__video' );
    $(video).trigger('play');
  }
});
 $(window).on('resize', function(){
  if( $('.section--hero').css('display') == 'flex')  {
    var video = ( '.hero__video' );
    $(video).trigger('play');
  }
});

/**
 * Set all membership sidebars to the same height as the tallest div 
 */

 $(document).ready(function() {
   var heightArray = $('.section--membership .sidebar--membership').map(function() {
    return  $(this).height();
  }).get();
   var maxHeight = Math.max.apply(Math, heightArray);
   $('.sidebar--membership').height(maxHeight);
 });

/**
 * Datepicker
 */
 
 $('#group-stats-start-date').datepicker({
  dateFormat: 'dd MM yy',
  altField: "#group-stats-start-date-raw",
  altFormat: "yy-mm-dd",
  defaultDate: '-1m',
  maxDate: 0,
  changeMonth: true,
  onClose: function(selectedDate) {
    $('#group-stats-end-date').datepicker('option', 'minDate', selectedDate);
  }
});

 $('#group-stats-end-date').datepicker({
  dateFormat: 'dd MM yy',
  altField: "#group-stats-end-date-raw",
  altFormat: "yy-mm-dd",
  defaultDate: 1,
  maxDate: 1,
  changeMonth: true,
  onClose: function(selectedDate) {
    var dt = new Date($(this).datepicker("getDate"));
    dt.setDate(dt.getDate() - 1);
    $('#group-stats-start-date').datepicker('option', 'maxDate', dt);
  }
});

/**
 * CTA banner
 */

 $(window).on('load', function() {
  if ($('header').hasClass('header--cta'))
  {
    setTimeout(function(){
      $('.cta-banner').slideDown();
    }, 1000);
  }
});

 $('.cta-close').on('click', function(e){
  e.preventDefault();
  $('.cta-banner').slideUp();
  $.cookie('cta-banner', 1, { expires : 1 });
  
});

 $('.cta-link').on('click', function() {
  $.cookie('cta-banner', 1, { expires : 1 }); 
})


/**
 * Filter Groups
 */

 $('.js-group').on( 'change', function() {
  var filterValue = $(this).val();

  $('.data-user').filter(function() {
    var user = $(this);
    var group = $(this).data('group');

    if ( group != filterValue )
    {
      user.parents('.row').addClass('hidden');
    }
    else
    {
      user.parents('.row').removeClass('hidden');
    }

    if ( filterValue == 'all' )
    {
      user.parents('.row').removeClass('hidden');
    }

  })
});


/* *
 * Nav Panel
 * */

if ( windowWidth >= 1200 )
 {
  var timer;
  var delay = 300;

  $('li.nav-panel-item').hover(function() {
    var panel = $(this).find('a').attr('title');

    const target = $('.nav-panel[data-panel="'+ panel +'"]');

    timer = setTimeout(function() {
      // $('body').addClass('nav-panel-active');
      target.addClass('active');
      $('.nav-panel').not(target).removeClass('active');
      // $('.header').addClass('fixed');
    }, delay);

  }, function() {
    clearTimeout(timer);

    target.removeClass('active');
    $('.header').removeClass('fixed');
  });

  $('.nav-panel').on( 'mouseleave', function(e) {
    $(this).removeClass('active');
    $('.header').removeClass('fixed');
    $('body').removeClass('nav-panel-active');
  });

}
else
{
  $('li.nav-panel-item > a').on( 'click', function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    $(this).addClass('active');
    var sub_menu = $(this).parent().find('.sub-menu');

    if ( sub_menu.hasClass('open') )
    {
      location.href = href;
    }

    sub_menu.slideToggle().addClass('open');

  });
}


/**
 * Subgroup User Dropdown
 */

 $('.sub-group-user').on( 'click', function(e) {
  e.preventDefault();
  var user_id = $(this).data('user');
  var sub_group_courses = $('.subgroup-user-courses[data-user="'+ user_id +'"]');
  sub_group_courses.slideToggle();

  if ( $(this).parents('.row--subgroup-user').length )
  {
    $(this).parents('.row--subgroup-user').toggleClass('active');
  }
})

/**
 * Group Statistics Overview
 */

 $(window).on( 'load', function() {
  var group_data = $('.group-data');

  if ( group_data.length )
  {
    var groups = group_data.data('groups');
    var users = group_data.data('users');
    var engagement = group_data.data('engagement');
    $('.statistics__groups').text(groups).addClass('loaded');
    $('.statistics__users').text(users).addClass('loaded');
    $('.statistics__engagement').text(engagement).addClass('loaded');
  }
})


/**
 * Thank you message/download link once Mailchimp form submitted
 */


 var mc1Submitted = false;
 $('#mc-embedded-subscribe-form').on('submit reset', function (event) {
  if ("submit" === event.type) 
  {
    mc1Submitted = true;
  } 
  else if ( "reset" === event.type && mc1Submitted ) 
  {
    $('.download__form, .download__content').fadeOut();
    setTimeout(function() {
      $('.download__success').fadeIn();
      if ( $('.download__success .download__button').length )
      {
              // var url = $('.download__button').attr('href'); 
              // window.open( url, '_blank' );
            }
          }, 1000)
  }
});

 $(document).ready(function() {
   var heightArray = $('.section--download').map(function() {
    return  $(this).height();
  }).get();
   var maxHeight = Math.max.apply(Math, heightArray);
   $('.section--download').height(maxHeight);
 });


/**
 * Membership header toggle
 */


 $('.membership__header__link').on( 'click', function(e) {
  e.preventDefault();
  var membership = $(this).parents().data('membership');
  $('[data-membership="' + membership + '"], .col--2_5--' + membership).toggleClass( 'active' );
  $('.membership__header, .col--lg-4, .btn').not('[data-membership="' + membership + '"], .col--2_5--' + membership).removeClass( 'active' );
});


/* *
 * Individual Membership Modal
 * */

 $('.membership__modal-button').on('click', function(e) { 
  e.preventDefault();
  $('.membership-modal').fadeIn().addClass('visible');
  $('body').addClass('hidden');
  $('.membership-modal__close, .body__overlay').on('click', function(e) { 
    $('.membership-modal').fadeOut().removeClass('visible');
    $('body').removeClass('hidden');
  });
});


/* *
 * "Other" field for trial from
 * */


 $('#how_did_you_hear_about_us').on('change', function(e) { 
  e.preventDefault();
  var option = $(this);
  if ( option.val() == 'Other' )
  {
    $('#how_did_you_hear_about_us_other_field').slideDown();
  }
});

 $('#membership_interest').on('change', function(e) { 
  e.preventDefault();
  var option = $(this);
  if ( option.val() == 'Other' )
  {
    $('#membership_interest_other_field').slideDown();
  }
});


/* *
 * Products filter
 * */


var filterOptions = [];
var form = $('#product-filter');
var qsRegex;
var pageNum;

function initInfiniteScroll(path) {
  let infScroll = new InfiniteScroll('.row--products', {
    path: '.next',
    history: false,
  });
}

$('.filter__option').on( 'change', function( ) {

  filterOptions = [];

  $('.filter__option').each(function() {

    var taxonomy = $(this).data('taxonomy');
    var term_id = $(this).data('term_id');

    if ( $(this).is(':checked') ) {
      filterOptions.push({
        taxonomy : taxonomy, 
        term_id : term_id
      });
    } 
    else {
      filterOptions = $.grep(filterOptions, function(e){ 
        return e.term_id != term_id; 
      });
    }
  });

  $('#clear-filters').fadeIn();

  $.ajax({
    url: form.attr('action'),
    type: 'POST',
    data: {
      action: 'products_filter',
      data: filterOptions,
      search: qsRegex || '',
      paged: pageNum || 1
    },
    beforeSend: function() {
      $('.section--products .col--lg-9 .row').prepend('<div class="spinning-loader"></div>');
      $('.card').addClass('loading');
    },
    success: function(data) {
      $('.spinning-loader').fadeOut(200, function() {
        $('.spinning-loader').remove();   
      });
      $('.card').removeClass('loading');
      var products = data.data;
      $('.row--products').html(products);
      if ( $('.products__no-results').is(':visible'))
      {
        $('.products__count-info').css('visibility', 'hidden');
      }
      else
      {
        $('.products__count-info').css('visibility', 'visible');
      }
      var updated_count = $('.updated_count').text();
      updated_count = parseInt(updated_count);
      $('.first-page-item').text(1);
      $('.products__count').text(updated_count);
      if ( updated_count < 24 )
      {
        $('.last-page-item').text(updated_count);
      }
      else
      {
        $('.last-page-item').text(24);
      }
    },

  });

  

});

var searchTerm = $('.products__search').keyup( debounce( function() {
  qsRegex = searchTerm.val();

  $('#clear-filters').fadeIn();

  $.ajax({
    url: form.attr('action'),
    type: 'POST',
    data: {
      action: 'products_filter',
      data: filterOptions,
      search: qsRegex || '',
      paged: pageNum || 1
    },
    beforeSend: function() {
      $('.section--products .col--lg-9 .row').prepend('<div class="spinning-loader"></div>');
      $('.card').addClass('loading');
    },
    success: function(data) {
      $('.spinning-loader').fadeOut(200, function() {
        $('.spinning-loader').remove();   
      });
      $('.card').removeClass('loading');
      var products = data.data;
      $('.row--products').html(products);
      if ( $('.products__no-results').is(':visible'))
      {
        $('.products__count-info').css('visibility', 'hidden');
      }
      else
      {
        $('.products__count-info').css('visibility', 'visible');
      }
      $('.first-page-item').text(1);
      var updated_count = $('.updated_count').text();
      updated_count = parseInt(updated_count);
      $('.products__count').text(updated_count);
      if ( updated_count < 24 )
      {
        $('.last-page-item').text(updated_count);
      }
      else
      {
        $('.last-page-item').text(24);
      }
    },

  });

  initInfiniteScroll();

}) );

// debounce so filtering doesn't happen every millisecond

function debounce( fn, threshold ) {
  var timeout;
  threshold = threshold || 300;
  return function debounced() {
    clearTimeout( timeout );
    var args = arguments;
    var _this = this;
    function delayed() {
      fn.apply( _this, args );
    }
    timeout = setTimeout( delayed, threshold );
  };
}


/* *
 * Pagination - before filter load
 * */

$(window).on('load', function(e) {
  e.preventDefault();

  var url = window.location.href;
  var arr = url.split('/');
  var pageNum = arr[arr.indexOf('page') + 1];

  if ( $.isNumeric( pageNum ) )
  {
    var firstItemCount = $('.first-page-item').text();
    firstItemCount = parseInt(firstItemCount);

    var updated_count = $('.products__count').text();
    updated_count = parseInt(updated_count);

    var lastPage = Math.ceil(updated_count / 24);
    var newLastItemCount = pageNum * 24;

    if ( pageNum == lastPage )
    {
      var lastPageItems = $('.card').length;
      lastPageItems = lastPageItems - 1;
      lastPageItems = lastPageItems;
      var newFirstItemCount = (updated_count - lastPageItems);
      $('.first-page-item').text(newFirstItemCount);
      $('.last-page-item').text(updated_count);
    }
    else
    {
      var newFirstItemCount = newLastItemCount - 23;
      $('.first-page-item').text(newFirstItemCount);
      $('.last-page-item').text(newLastItemCount);
    }

  }

});


/* *
 * Pagination - after filter load
 * */

$(document).on('click', '.pagination--query .page-numbers', function(e){
  e.preventDefault();

  var pageLink = $(this).attr('href');
  pageNum = pageLink.replace(/\D/g, '');

  var firstItemCount = $('.first-page-item').text();
  firstItemCount = parseInt(firstItemCount);

  var updated_count = $('.updated_count').text();
  updated_count = parseInt(updated_count);

  var lastPage = Math.ceil(updated_count / 24);

  $.ajax({
    url: form.attr('action'),
    type: 'POST',
    data: {
      action: 'products_filter',
      data: filterOptions,
      search: qsRegex || '',
      paged: pageNum || 1
    },
    beforeSend: function() {
      $('.section--products .col--lg-9 .row').prepend('<div class="spinning-loader"></div>');
      $('.card').addClass('loading');
    },
    success: function(data) {
      $('.spinning-loader').fadeOut(200, function() {
        $('.spinning-loader').remove();   
      });
      $('.card').removeClass('loading');
      var products = data.data;
      $('.row--products').html(products);
      var lastPageItems = $('.card').length;
      if ( pageNum == lastPage )
      {
        var lastPageItems = $('.card').length;
        lastPageItems = lastPageItems - 1;
        lastPageItems = lastPageItems;
        var newFirstItemCount = (updated_count - lastPageItems);
        $('.first-page-item').text(newFirstItemCount);
      }
      $('.pagination--query .page-numbers').on( 'click', function(e){
        e.preventDefault();
      });
    },

  });

  if ( pageNum == '' )
  {
    $('.first-page-item').text(1);
    $('.last-page-item').text(24);
  }
  else
  {
    var newLastItemCount = pageNum * 24;

    if ( pageNum == lastPage )
    {
      
      $('.last-page-item').text(updated_count);
    }
    else
    {
      var newFirstItemCount = newLastItemCount - 23;
      $('.first-page-item').text(newFirstItemCount);
      $('.last-page-item').text(newLastItemCount);
    }

  }

});


$('#product-filter').submit(function(e) {
  e.preventDefault();
});

$(window).on('load', function() {
  if ( $('.products__filter input.filter__option').is(':checked') )
  {
    filterOptions = [];

    $('.filter__option').each(function() {

      var taxonomy = $(this).data('taxonomy');
      var term_id = $(this).data('term_id');

      if ( $(this).is(':checked') ) {
        filterOptions.push({
          taxonomy : taxonomy, 
          term_id : term_id
        });
      } 
      else {
        filterOptions = $.grep(filterOptions, function(e){ 
          return e.term_id != term_id; 
        });
      }
    });

    $('#clear-filters').fadeIn();

    $.ajax({
      url: form.attr('action'),
      type: 'POST',
      data: {
        action: 'products_filter',
        data: filterOptions,
        search: qsRegex || '',
        paged: pageNum || 1
      },
      beforeSend: function() {
        $('.section--products .col--lg-9 .row').prepend('<div class="spinning-loader"></div>');
        $('.card').addClass('loading');
      },
      success: function(data) {
        $('.spinning-loader').fadeOut(200, function() {
          $('.spinning-loader').remove();   
        });
        $('.card').removeClass('loading');
        var products = data.data;
        $('.row--products').html(products);
        if ( $('.products__no-results').is(':visible'))
        {
          $('.products__count-info').css('visibility', 'hidden');
        }
        else
        {
          $('.products__count-info').css('visibility', 'visible');
        }
        var updated_count = $('.updated_count').text();
        updated_count = parseInt(updated_count);
        $('.first-page-item').text(1);
        $('.products__count').text(updated_count);
        if ( updated_count < 24 )
        {
          $('.last-page-item').text(updated_count);
        }
        else
        {
          $('.last-page-item').text(24);
        }
      },

    });
  }
}); 

// $('#clear-filters').on('click', function(e) {
//   e.preventDefault();
//   var checkbox = $('.filter__option');
//   checkbox.prop( 'unchecked' ); 
// })


/* *
 * Toggle product filters
 * */


const toggleProductFilters = (event) => {
  event.preventDefault();
  if ( $('.products__filter').is(':visible') )
  {
    $('.products__toggle').text('Show Filters');
  }
  else
  {
    $('.products__toggle').text('Hide Filters');
  }
  $('.products__filter').slideToggle();
};

$('.products__toggle').on('click', toggleProductFilters);